<template>
  <section v-if="categoryStore" class="category-shell">
    <div class="category-layout">
      <div class="category-header">
        <h1 class="category-title">{{ $t('category.title') }}</h1>
      </div>

      <div class="category-content">
        <p class="category-panel-title">{{ $t('category.prompt') }}</p>

        <div class="category-grid" :style="{ '--category-rows': Math.max(1, Math.ceil((categoryStore.categories?.length || 0) / 3)) }">
          <button
            v-for="item in categoryStore.categories"
            :key="item.id"
            type="button"
            class="category-option"
            :class="{ 'category-option--selected': isSelected(item.id) }"
            @click="toggleCategory(item.id)"
          >
            <span class="category-option-media">
              <img
                :src="item.media?.fullPath || item.media?.image"
                class="category-image"
                :alt="item.name"
              >
            </span>

            <span class="category-option-copy">
              <span class="category-option-name">{{ item.name }}</span>
            </span>

            <span class="category-option-check" :class="{ 'category-option-check--selected': isSelected(item.id) }">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.4" />
              </svg>
            </span>
          </button>
        </div>

        <div class="category-actions">
          <button type="button" class="category-complete-button" :disabled="!hasSelection()" @click="setSelectedCategoryIds">
            <span>{{ $t('common.complete') }}</span>
            <svg class="category-complete-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" aria-hidden="true"><path d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" /></svg>
          </button>

          <router-link :to="{ path: '/duties' }" class="category-later-link">
            {{ $t('common.later') }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { defineComponent, onMounted } from 'vue'
import { useCategoryStore } from '@/store/category'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'ProfileView',
  setup () {
    history.pushState(null, null, location.href)
    window.onpopstate = function () {
      history.go(1)
    }
    const router = useRouter()
    const categoryStore = useCategoryStore()
    onMounted(() => {
      categoryStore.getCategoryList()
    })

    const isSelected = (categoryId) => {
      return categoryStore.selectedCategoryIds.includes(categoryId)
    }

    const hasSelection = () => {
      return categoryStore.selectedCategoryIds.length > 0
    }

    const toggleCategory = (categoryId) => {
      if (isSelected(categoryId)) {
        categoryStore.selectedCategoryIds = categoryStore.selectedCategoryIds.filter((id) => id !== categoryId)
        return
      }

      categoryStore.selectedCategoryIds = [...categoryStore.selectedCategoryIds, categoryId]
    }

    const setSelectedCategoryIds = () => {
      if (!hasSelection()) {
        return
      }

      categoryStore.setSelectedCategoryIds().then(
        response => {
          if (response.status === 200) {
            router.push('/duties')
          }
        }
      )
    }
    return {
      categoryStore,
      hasSelection,
      isSelected,
      setSelectedCategoryIds,
      toggleCategory
    }
  }
})
</script>
<style scoped lang="scss">
@import '@/styles/pages/category.scss';
</style>
